// extracted by mini-css-extract-plugin
export default {"mainContainer":"ContactInfo_mainContainer__+qVS7","cardInfo":"ContactInfo_cardInfo__0cHGW"};